export default {
  get: {
    getSystemsDynamic: '/api/system/systems-dynamic',

    getDynamicsList: '/api/system/get-dynamics-list',

    getAdvList: '/api/adv/adv-list',
    getAdvSystemList: '/api/adv/adv-system-list',
    getQuota: '/api/helpdesk/quota'
  },
  post: {
    postSaveDynamicVisitLog: '/api/system/save-dynamic-visit-log',
    postSaveFavoriteVisitLog: '/api/system/save-favorite-visit-log'
  }
}


